import * as z from "zod";
import { grantsForScope } from "../rbac/grantQueries";
import { BUILTIN_ROLES, type BuiltinRoleId } from "../rbac/roles";
import { mutator } from "./mutator";

export const deleteNetwork = mutator({
  schema: z.object({ networkId: z.string() }),
  resolve: {
    network: { kind: "network", from: "networkId" },
  },
  permissions: [
    { permission: "network:write", scopeId: ({ args }) => args.network.id },
  ],
  fn: async ({ tx, args: { network } }) => {
    const grants = await tx.run(grantsForScope(network.id, network.tenantId));
    for (const g of grants) {
      const scopeKind = g.builtinRoleId
        ? BUILTIN_ROLES[g.builtinRoleId as BuiltinRoleId]?.scopeKind
        : g.customRole?.scopeKind;
      if (scopeKind !== "network") continue;
      await tx.mutate.roleGrants.delete({ id: g.id });
    }
    await tx.mutate.networks.delete({ id: network.id });
  },
});
